import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  padding: 24px;

  background: ${({ theme }) => theme.colors.greys.lightest};
  box-shadow: ${({ theme }) => theme.shadows.short};
  border-radius: ${({ theme }) => theme.borders.radius.weak};
`;

export const TitleRow = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 24px;
`;

export const ToggleContainer = styled.div`
  width: 240px;
`;

/*
 * The header row and every data row use "display: contents" so all their cells become direct
 * children of this grid and share the same column tracks, keeping header and data columns
 * aligned regardless of content (e.g. the sync icon only showing on some rows).
 */
export const Table = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(160px, 1.3fr) minmax(140px, 1fr) 100px 100px 100px 100px;
  align-items: center;
`;

export const TableHeaderRow = styled.div`
  display: contents;

  > div {
    padding-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
  }
`;

export const TableRow = styled.div`
  display: contents;

  > div {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  &:not(:last-of-type) > div {
    border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
  }
`;

export const CentralKitchenCell = styled.div`
  min-width: 0;
  padding-right: 16px;

  display: flex;
  align-items: center;
  column-gap: 6px;
`;

export const CentralKitchenName = styled.div`
  min-width: 0;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const PackagingCell = styled.div`
  min-width: 0;
`;

export const SyncIconSlot = styled.div`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SyncBadge = styled.div`
  width: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme }) => theme.colors.brand.primary};
  border-radius: 50%;
`;

export const SyncIcon = styled.img`
  width: 10px;
  height: 10px;
`;

export const MetricCell = styled.div`
  min-width: 0;

  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const SortableHeader = styled.div`
  width: fit-content;

  display: flex;
  align-items: center;
  column-gap: 4px;

  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const SortIcon = styled.img`
  width: 10px;
  height: 10px;
  flex-shrink: 0;

  transform: ${({ $isDescending }) => ($isDescending ? 'rotate(180deg)' : 'none')};
`;
